import {
  ContentCopyRounded,
  DateRange, DeleteOutlined, MoreHoriz, Search, VisibilityOutlined,
} from '@mui/icons-material';
import {
  Alert, IconButton, Menu, MenuItem, Snackbar, TextField,
} from '@mui/material';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getTransactions } from '../../../../Redux/Models/transaction';
import Elements from '../../../Elements';

export default function AllTransactions({
  transactions, classes, error, message,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [type, setType] = useState(1);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getTransactions());
  }, []);

  return (
    <Elements.AdminPageBase
      navigate={navigate}
      title="Transactions"
      additionalStuff={(
        <div className={classes.type}>
          <div className="flex gap-16 mt-4">
            <div className={`link type ${type === 1 ? 'selected' : ''}`} onClick={() => setType(1)}>Storage transactions</div>
            <div className={`link type ${type === 2 ? 'selected' : ''}`} onClick={() => setType(2)}>Market transactions</div>
            {/* <div
              className={`link type ${type === 3 ? 'selected' : ''}`}
              onClick={() => setType(3)}
            >
              Subscription transactions
            </div> */}
          </div>
          <div className="flex mt-3" style={{ width: '80%' }}>
            <TextField
              placeholder="Search by keyword"
              size="small"
              InputProps={{
                endAdornment: (<Search />),
              }}
              fullWidth
            />
            <TextField
              placeholder="Filter by date"
              size="small"
              InputProps={{
                endAdornment: (<DateRange />),
              }}
              fullWidth
            />
            <TextField select size="small" fullWidth value="-">
              <MenuItem value="-">Sort by</MenuItem>
              <MenuItem>Newest</MenuItem>
              <MenuItem>Oldest</MenuItem>
            </TextField>
            <TextField select size="small" fullWidth value="-">
              <MenuItem value="-">15 list</MenuItem>
              <MenuItem>30 list</MenuItem>
              <MenuItem>50 list</MenuItem>
            </TextField>
          </div>
          <div className="very-mute mt-1 s-14">1200 results</div>
        </div>
    )}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <div className="">
          <table>
            <thead>
              <tr>
                <td className="weight-700">Order ID</td>
                <td className="weight-700">Sale type</td>
                <td className="weight-700">Service</td>
                <td className="weight-700">Status</td>
                <td className="weight-700">Order date</td>
                <td className="weight-700">Price</td>
                <td className="weight-700">Volume</td>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction) => (
                <TransactionData transaction={transaction} key={transaction.order?.id} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Elements.AdminPageBase>
  );
}

function TransactionData({ transaction }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const copyOrderId = () => {
    navigator.clipboard.writeText(transaction.order?.id);
  };
  return (
    <tr key={transaction.order?.id}>
      {/* data */}
      <td>
        <div className="flex gap-4 align-items-center">
          <IconButton onClick={copyOrderId}>
            <ContentCopyRounded />
          </IconButton>
          {transaction.order?.id?.substr(0, 4)}
          ...
        </div>
      </td>
      <td>{transaction.item?.sale_type}</td>
      <td>{transaction.order?.service}</td>
      <td>{transaction.order?.status}</td>
      <td>{moment(new Date(transaction.order?.created_at)).format('MMM, DD yyyy')}</td>
      <td>
        ₣
        {transaction.item?.price}
      </td>
      <td>
        {transaction.item?.volume}
      </td>
      <td>
        <IconButton sx={{ p: 0, ml: 2 }} onClick={handleClick}>
          <MoreHoriz />
        </IconButton>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleClose}>
            <VisibilityOutlined fontSize="small" sx={{ mr: 1 }} color="info" />
            {' '}
            Details
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <DeleteOutlined fontSize="small" sx={{ mr: 1 }} color="error" />
            {' '}
            Delete
          </MenuItem>
        </Menu>
      </td>
    </tr>
  );
}
